import "./field.scss";
import { DATE_DELIMITER } from "./constants";
import {
  applyStyleHandler,
  clearFieldHandler,
  focusHandler,
  revalidateHandler,
  setPlaceholderHandler,
} from "./commonHandlers";
import { notifyCard } from "./iframeNotifications";

export const fieldProcessor = (
  onChange: (
    event: Event,
    notifyCard: (data: Record<string, unknown>) => void
  ) => void,
  onLoaded?: (
    input: HTMLInputElement,
    notifyCard: (data: Record<string, unknown>) => void
  ) => void
) => {
  document.addEventListener("DOMContentLoaded", () => {
    const fieldElement = document.querySelector("input");

    onLoaded && onLoaded(fieldElement, notifyCard);

    fieldElement.addEventListener("input", (event) => {
      onChange(event, notifyCard);
    });
  });

  window.addEventListener("message", applyStyleHandler, false);
  window.addEventListener("message", focusHandler, false);
  window.addEventListener("message", clearFieldHandler, false);
  window.addEventListener("message", setPlaceholderHandler, false);
  window.addEventListener("message", revalidateHandler, false);
};

export const fieldProcessor2 = (onFieldReady: () => void) => {
  document.addEventListener("DOMContentLoaded", onFieldReady);

  window.addEventListener("message", applyStyleHandler, false);
  window.addEventListener("message", focusHandler, false);
  window.addEventListener("message", clearFieldHandler, false);
  window.addEventListener("message", setPlaceholderHandler, false);
  window.addEventListener("message", revalidateHandler, false);
};

export const getExpireDateParts = (value: string) =>
  value.split(DATE_DELIMITER);
